import { render, staticRenderFns } from "./FavouritesButton.vue?vue&type=template&id=3affc82d&"
import script from "./FavouritesButton.vue?vue&type=script&lang=js&"
export * from "./FavouritesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports